<script setup lang="ts">
import { computed, inject, Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Subjekt } from '/@src/client-portal'

const emptyResponse = inject<any>('emptyResponse')
const isReadOnly = inject<boolean>('isReadOnly')
const subjektDetail = inject<Ref<Subjekt>>('subjektDetail')
const { t } = useI18n()

const adresa = computed(() => {
  if (isReadOnly) return emptyResponse.ziadatel.osoba.osobaRef
  return subjektDetail?.value?.osoba?.primarnaAdresa
})
</script>

<template>
  <DisplayList
    v-if="!isReadOnly"
    bold="title"
    variant="inline"
    inline-layout="one-half"
    class="mb-6"
  >
    <dt>{{ t('zoppm.step7.fyzickaOsoba.pobyt') }}</dt>
    <dd><Address :data="adresa" /></dd>
  </DisplayList>
  <DisplayList v-else bold="title" variant="inline" inline-layout="one-half" class="mb-6">
    <dt>{{ t('zoppm.step7.fyzickaOsoba.pobyt') }}</dt>
    <dd>{{ t('zoppm.step7.pravnickaOsoba.adresaVzorova') }}</dd>
  </DisplayList>
</template>

<style lang="scss">
.bold {
  font-weight: bold;
}
</style>
